// Libraries
import { Divider, Grid, Typography } from "@mui/material";
import { memo } from "react";

// Components
import CollapsibleCard from "@/Layouts/components/Cards/CollapsibleCard";
import DrawTable from "./DrawTable";

// Types
import { TDrawRecord } from "../types";

// Utils
import { or } from "@/Common/helpers/sonar";

type TDrawDepartmentSectionProps = {
	departmentName: string;
	displayDivider: boolean;
	globalSearch: string;
	positions: any[];
};

function DrawDepartmentSection(props: Readonly<TDrawDepartmentSectionProps>) {
	const { departmentName, displayDivider, positions, globalSearch } = props;

	function globalFilter(records: Omit<TDrawRecord, "hierarchy" | "searchName">[]) {
		const search = globalSearch.toLowerCase();
		if (!search) {
			return records;
		}

		return records.filter((record) => filterDraws(record, search));
	}

	function filterDraws(record: Omit<TDrawRecord, "hierarchy" | "searchName">, search: string) {
		const fullName = record?.fullName.toLowerCase() ?? "";
		const overdraw = String(record?.overdraw ?? "");
		const draws = record.draws?.find((draw) => or(String(draw.amount).includes(search), draw.drawType.includes(search)));

		return or(fullName.includes(search), overdraw.includes(search), Boolean(draws));
	}

	if (!positions?.length) {
		return null;
	}

	return (
		<Grid item xs={12} className="!pt-[24px]">
			<CollapsibleCard
				expanded={true}
				customTitle={departmentName}
				sxActions={{ px: 0 }}
				customTitleClasses="!text-[24px] !font-montserrat !font-medium"
			>
				<Grid container columnSpacing={4}>
					{positions?.map((element: any) => {
						if (!element.records?.length) {
							return null;
						}

						return (
							<Grid item key={element.position} xs={4}>
								<Typography className={"regular-montserrat-label fs-16 !text-neutral-gray pl-[15px] pb-2"} component="div">
									{element.position}
								</Typography>

								<Grid item className="!mb-[32px]">
									<DrawTable
										position={element.position}
										department={departmentName}
										data={globalFilter(element.records)}
									/>
								</Grid>
							</Grid>
						);
					})}
				</Grid>
			</CollapsibleCard>
			{displayDivider && <Divider className="!border-disabled" />}
		</Grid>
	);
}

export default memo(DrawDepartmentSection);
